<template>
    <div class="slide-verify" id="slideVerify" onselectstart="return false;">
        <canvas :width="block_w" :height="block_h" ref="canvas" ></canvas>
        <div @click="refresh" class="slide-verify-refresh-icon"></div>
        <canvas :width="block_w" :height="block_h" ref="block"  class="slide-verify-block"></canvas>
        <!-- container -->
        <div class="slide-verify-slider" :class="{'container-active': containerActive, 'container-success': containerSuccess, 'container-fail': containerFail}">
            <div class="slide-verify-slider-mask" :style="{width: sliderMaskWidth}">
                <!-- slider -->
                <div @mousedown="sliderDown"
                    @touchstart="touchStartEvent"
                    @touchmove="touchMoveEvent"
                    @touchend="(e)=>touchEndEvent(e)"
                    class="slide-verify-slider-mask-item"
                    :style="{left: sliderLeft}">
                    <div class="slide-verify-slider-mask-item-icon"></div>
                </div>
            </div>
            <span class="slide-verify-slider-text">{{sliderText}}</span>
        </div>
    </div>
</template>
<script>
import AES from '@/common/aes';
    const PI = Math.PI;
    function sum(x, y) {
        return x + y
    }
    function square(x) {
        return x * x
    }
    export default {
        name: 'SlideVerify',
        props: {
            type: {
                type: [Number,String],
                default: "1",
            },
            // block length
            l: {
                type: Number,
                default: 42,
            },
            // block radius
            r: {
                type: Number,
                default: 10,
            },
            // canvas width
            w: {
                type: Number,
                default: 365,
            },
            // canvas height
            h: {
                type: Number,
                default: 180,
            },
            sliderText: {
                type: String,
                default: 'Slide filled right',
            },
            phone: {
                type: String,
                default: '',
            },
            sliderType: {
                type: String,
                default: 'TEXT',
            },
        },
        data() {
            return {
                containerActive: false, // container active class
                containerSuccess: false, // container success class
                containerFail: false, // container fail class
                canvasCtx: null,
                blockCtx: null,
                block: null,
                block_x: undefined, // container random position
                block_y: undefined,
                block_w: undefined,
                block_h: undefined,
                L: this.l + this.r * 2 + 3, // block real lenght
                img: undefined,
                originX: undefined,
                originY: undefined,
                isMouseDown: false,
                trail: [],
                key: '',
                sliderLeft: 0, // block right offset
                sliderMaskWidth: 0, // mask width,
            }
        },
        mounted() {
            this.key = "code-"+this.phone
            console.log('window.rem')
            console.log(window.rem)
            this.block_w = this.w
            this.block_h = this.h
            this.init()
            // let that = this
            // window.addEventListener('resize', ()=>{
            //     console.log('window.rem resize')
            //     console.log(window.rem)
            //     that.block_w = 2.099*window.rem
            //     that.block_h = 0.944*window.rem
            //     that.init()
            // }, false);
        },
        methods: {
            debounce(fn, delay) {
                let timer = null;
                return function(...args) {
                    if (timer) clearTimeout(timer); // 清除旧计时 
                    timer = setTimeout(() => {
                    fn.apply(this,  args); // 确保正确的 this 指向和参数传递 
                    }, delay);
                };
            },
            init() {
                this.initDom()
                this.initImg()
                this.bindEvents()
            },
            initDom() {
                this.block = this.$refs.block;
                this.canvasCtx = this.$refs.canvas.getContext('2d')
                this.blockCtx = this.block.getContext('2d')
            },
             initImg() {
                const img = this.createImg(async () => {
                    await this.drawBlock()
                    this.canvasCtx.drawImage(img, 0, 0, this.block_w, this.block_h)
                    this.blockCtx.drawImage(img, 0, 0, this.block_w, this.block_h)
                    let {
                        block_x: x,
                        block_y: y,
                        r,
                        L
                    } = this
                    let _y = y - r * 2 - 1
                    let ImageData = this.blockCtx.getImageData(x, _y, L, L);
                    this.block.width = L;
                    this.blockCtx.putImageData(ImageData, 0, _y)
                });
                this.img = img;
            },
            async getPhoneValidCode(){
                if (this.phone == '' || !this.rules.tel.test(this.phone)) {
                    // this.toast('手机号码格式不正确', 'error');
                    return 100
                }
                let res = await this.$axios.post('/user/getPhoneValidCode',{
                    phone: this.phone,
                    minValue: 80,
                    maxValue: Math.floor(this.block_w - 80),
                    type: this.type
                })
                console.log(res)
                const decrypted = await AES.decrypt(res,this.key);
                console.log(decrypted)
                return decrypted
            },
            async drawBlock () {
                // this.block_x = this.getRandomNumberByRange(this.L + 10, this.block_w - (this.L + 10))
                this.block_x = Number(await this.getPhoneValidCode())
                this.block_y = this.getRandomNumberByRange(10 + this.r * 2, this.block_h - (this.L + 10))
                this.draw(this.canvasCtx, this.block_x, this.block_y, 'fill')
                this.draw(this.blockCtx, this.block_x, this.block_y, 'clip')
            },
            draw(ctx, x, y, operation) {
                let {
                    l,
                    r
                } = this;
                ctx.beginPath()
                ctx.moveTo(x, y)
                ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI)
                ctx.lineTo(x + l, y)
                ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI)
                ctx.lineTo(x + l, y + l)
                ctx.lineTo(x, y + l)
                ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true)
                ctx.lineTo(x, y)
                ctx.lineWidth = 2
                ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
                ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)'
                ctx.stroke()
                ctx[operation]()
                ctx.globalCompositeOperation = 'overlay'
            },
            createImg(onload) {
                const img = document.createElement('img');
                img.crossOrigin = "Anonymous";
                img.onload = onload;
                img.onerror = () => {
                    img.src = this.getRandomImg()
                }
                img.src = this.getRandomImg()
                return img;
            },
            // 随机生成img src
            getRandomImg() {
                // return 'https://picsum.photos/300/150/?image=' + this.getRandomNumberByRange(0, 1084);
                return require(`../../../static/images/validCode/validCode${this.getRandomNumberByRange(1, 8)}.jpg`)
            },
            getRandomNumberByRange(start, end) {
                return Math.round(Math.random() * (end - start) + start)
            },
            refresh() {
                this.reset()
                this.$emit('refresh')
            },
            sliderDown(event) {
                this.originX = event.clientX;
                this.originY = event.clientY;
                this.isMouseDown = true;
            },
            touchStartEvent(e) {
                this.originX = e.changedTouches[0].pageX;
                this.originY = e.changedTouches[0].pageY;
                this.isMouseDown = true;
            },
            bindEvents() {
                document.addEventListener('mousemove', (e) => {
                    if (!this.isMouseDown) return false;
                    const moveX = e.clientX - this.originX;
                    const moveY = e.clientY - this.originY;
                    if (moveX < 0 || moveX + 38 >= this.block_w) return false;
                    this.sliderLeft = moveX + 'px';
                    let blockLeft = (this.block_w - 40 - 20) / (this.block_w - 40) * moveX;
                    this.block.style.left = blockLeft + 'px';
                    this.containerActive = true; // add active
                    this.sliderMaskWidth = moveX + 'px';
                    this.trail.push(moveY);
                });
                document.addEventListener('mouseup', async (e) => {
                    if (!this.isMouseDown) return false
                    this.isMouseDown = false
                    if (e.clientX === this.originX) return false;
                    this.containerActive = false; // remove active
                    const {
                        spliced,
                        TuringTest
                    } = await this.verify();
                    console.log('verify spliced')
                    console.log(spliced)
                    console.log(TuringTest)
                    if (spliced) {
                        if (TuringTest) {
                            // succ
                            this.containerSuccess = true;
                            this.$emit('success')
                        } else {
                            this.containerFail = true;
                            this.sliderText = 'try again'
                            this.reset()
                        }
                    } else {
                        this.containerFail = true;
                        this.$emit('fail')
                        setTimeout(() => {
                            this.reset()
                        }, 1000)
                    }
                })
            },
            touchMoveEvent(e) {
                if (!this.isMouseDown) return false;
                const moveX = e.changedTouches[0].pageX - this.originX;
                const moveY = e.changedTouches[0].pageY - this.originY;
                if (moveX < 0 || moveX + 38 >= this.block_w) return false;
                this.sliderLeft = moveX + 'px';
                let blockLeft = (this.block_w - 40 - 20) / (this.block_w - 40) * moveX;
                this.block.style.left = blockLeft + 'px';
                this.containerActive = true;
                this.sliderMaskWidth = moveX + 'px';
                this.trail.push(moveY);
            },
            async touchEndEvent(e) {
                if (!this.isMouseDown) return false
                this.isMouseDown = false
                if (e.changedTouches[0].pageX === this.originX) return false;
                this.containerActive = false;
                let {
                    spliced,
                    TuringTest
                } = await this.verify();
                console.log('verify spliced')
                console.log(spliced)
                console.log(TuringTest)
                if (spliced) {
                    if (TuringTest) {
                        // succ
                        this.containerSuccess = true;
                        this.$emit('success')
                    } else {
                        this.containerFail = true;
                        this.sliderText = 'try again'
                        this.reset()
                    }
                } else {
                    this.containerFail = true;
                    this.$emit('fail')
                    setTimeout(() => {
                        this.reset()
                    }, 1000)
                }
            },
            async getSpliced (left){
                console.log(this.sliderType,'this.sliderType')
                let url = this.sliderType == 'TEXT' ? '/user/sendPhoneCode.origin' : '/user/sendPhoneVoiceCode.origin'
                let res = await this.$axios.post(url,{
                    phone:this.phone,
                    type: this.type,
                    captchaValue: left,
                })

                // if (res.data.code != 10000000 && res.data.msg){
                //     this.$Notice.error({
                //         title: '系统提示',
                //         desc: res.data.msg
                //     });
                //     return false
                // }
                if (res.data.code == 10000000){
                    this.toast('发送成功')
                    return true
                }else{
                    this.$Notice.error({
                        title: '系统提示',
                        desc: res.data.msg
                    });
                    return false
                }
            },
            async verify() {
                const arr = this.trail // drag y move distance
                const average = arr.reduce(sum) / arr.length // average
                const deviations = arr.map(x => x - average) // deviation array
                const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length) // standard deviation
                const left = parseInt(this.block.style.left)
                console.log('average')
                console.log(average)
                console.log(stddev)
                console.log(left)
                const spliced = await this.getSpliced(left)
                console.log(spliced)
                return {
                    // spliced: Math.abs(left - this.block_x) < 10,
                    spliced: spliced,
                    TuringTest: average !== stddev, // equal => not person operate
                }
            },
            reset() {
                this.key = "code-" + this.phone
                this.containerActive = false;
                this.containerSuccess = false;
                this.containerFail = false;
                this.sliderLeft = 0;
                this.block.style.left = 0;
                this.sliderMaskWidth = 0;
                // canvas
                let {
                    block_w,
                    block_h
                } = this;
                this.canvasCtx.clearRect(0, 0, block_w, block_h)
                this.blockCtx.clearRect(0, 0, block_w, block_h)
                this.block.width = block_w
                // generate img
                this.img.src = this.getRandomImg()
            }
        }
    }
</script>
<style scoped>
    .slide-verify {
        position: relative;
        /* width: 310px; */
        width: 100%;
    }
    .slide-verify-block {
        position: absolute;
        left: 0;
        top: 0
    }
    .slide-verify-refresh-icon {
        position: absolute;
        right: 12px;
        top: 10px;
        width: 24px;
        height: 24px;
        cursor: pointer;
        background: url("../../../static/images/validCode/refresh.png");
        background-size: 100% 100%;
    }
    .slide-verify-slider {
        position: relative;
        text-align: center;
        /* width: 310px; */
        width: 100%;
        height: 40px;
        line-height: 40px;
        margin-top: 15px;
        background: #f7f9fa;
        color: #45494c;
        border: 1px solid #e4e7eb;
    }
    .slide-verify-slider-mask {
        position: absolute;
        left: 0;
        top: 0;
        height: 38px;
        border: 0 solid #1991FA;
        background: #D1E9FE
    }
    .slide-verify-slider-mask-item {
        position: absolute;
        top: 0;
        left: 0;
        width: 38px;
        height: 38px;
        background: #fff;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
        cursor: pointer;
        transition: background .2s linear
    }
    .slide-verify-slider-mask-item:hover {
        background: #1991FA
    }
    .slide-verify-slider-mask-item:hover .slide-verify-slider-mask-item-icon {
        background: url("../../../static/images/validCode/arrowActive.png");
        background-size: 100% 100%;
    }
    .slide-verify-slider-mask-item-icon {
        position: absolute;
        top: 6px;
        left: 6px;
        width: 25px;
        height: 25px;
        background: url("../../../static/images/validCode/arrowNormal.png");
        background-size: 100% 100%;
    }
    .container-active .slide-verify-slider-mask-item {
        height: 38px;
        top: -1px;
        border: 1px solid #1991FA;
        background: #1991FA
    }
    .container-active .slide-verify-slider-mask {
        height: 38px;
        border-width: 1px;
    }
    .container-success .slide-verify-slider-mask-item {
        height: 38px;
        top: -1px;
        border: 1px solid #52CCBA;
        background-color: #52CCBA !important;
        background-color: #D2F4EF;
    }
    .container-success .slide-verify-slider-mask {
        height: 38px;
        border: 1px solid #52CCBA;
        background-color: #D2F4EF;
    }
    .container-success .slide-verify-slider-mask-item-icon {
        background: url("../../../static/images/validCode/successActive.png");
        background-size: 100% 100%;
    }
    .container-fail .slide-verify-slider-mask-item {
        height: 38px;
        top: -1px;
        border: 1px solid #f57a7a;
        background-color: #f57a7a !important;
        background-color: #fce1e1;
    }
    .container-fail .slide-verify-slider-mask {
        height: 38px;
        border: 1px solid #f57a7a;
        background-color: #fce1e1;
    }
    /* .container-fail .slide-verify-slider-mask-item-icon {
        top: 14px;
        background-position: 0 -82px !important;
    } */
    .container-active .slide-verify-slider-text,
    .container-success .slide-verify-slider-text,
    .container-fail .slide-verify-slider-text {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/SlideVerify.vue